import React, { useContext, useState } from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import * as yup from 'yup';
import { Formik, ErrorMessage, Form, Field } from 'formik';
import { AuthContext } from '../../context/AuthContext';
import {useNavigate} from 'react-router-dom';

function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="http://localhost:3000">
        EthioGlobal
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

// TODO remove, this demo shouldn't need to reset the theme.

const defaultTheme = createTheme();

const countries = [
  { code: 'ET', label: 'Ethiopia', areaCode: '251' },
  { code: 'US', label: 'United States', areaCode: '1' },
  { code: 'CA', label: 'Canada', areaCode: '2' },
  { code: 'GB', label: 'United Kingdom', areaCode: '44' },
  { code: 'AU', label: 'Australia', areaCode: '61' },
  // Add more countries as needed
];

const NoDropdownArrow = () => <span />;

export default function SignUp() {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false);
  const { currentuser, registersupplier, err } = useContext(AuthContext);
  
  const [values, setValues] = useState({
    firstname: "",
    middlename: "",
    lastname: "",
    role: "",
    countryofresidence: "",
    mobilenumber: "",
    fixednumber: "",
    email: "",
    password: "",
    expotoken: "",
  })

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      setLoading(true);
      await registersupplier(values);
      // if(currentuser) {
      //   navigate('/');
      //   setNotification({
      //     show: true,
      //     type: 'success',
      //     message: 'Login successful!'
      //   });
      //   setIsRedirecting(true);
      //   const timer = setTimeout(() => {
      //   }, 3000);
      //   return () => clearTimeout(timer);
      // }
      // else {
      //   setNotification({
      //     show: true,
      //     type: 'error',
      //     message: 'Login failed. Please try again .'
      //   });
      // }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setNotification({
        show: true,
        type: 'error',
        message: error
      });
    } finally {
      setSubmitting(false);
      setIsRedirecting(false);
    }
  };

  const [notification, setNotification] = useState(null);
  const [isRedirecting, setIsRedirecting] = useState(false);

  const validationSchema = yup.object({
    firstname: yup.string()
      .required('First name is required'),
    middlename: yup.string()
      .required('Last name is required'),
    lastname: yup.string()
      .required('Last name is required'),
    countryofresidence: yup.string()
      .required('Country is required'),
    role: yup.string()
      .required('role is required'),
    country: yup.string()
      .required('Country code is required'),
    mobilenumber: yup.string()
      .required('Phone number is required')
      .matches(/^(0[79][0-9]{8}|[7-9][0-9]{8})$/, 'Invalid phone number format'),
    fixednumber: yup.string()
      .required('Phone number is required')
      .matches(/^(0[1-6][0-9]{8}|[1-6][0-9]{8})$/, 'Invalid phone number format'),
    email: yup.string()
      .email('Invalid email format'),
    password: yup.string()
      .min(6, 'Password must be at least 6 characters long')
      .required('Password is required'),
    confirmpassword: yup.string()
      .oneOf([yup.ref('password'), null], 'Passwords must match')
      .required('Confirm Password is required'),
    expotoken: yup.string()
  });

  return (
    <ThemeProvider theme={defaultTheme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign up
          </Typography>
          <Formik
            initialValues={{
              firstname: '',
              middlename: '',
              lastname: '',
              role: '',
              countryofresidence: 'Ethiopia',
              country: countries.length > 0 ? countries[0].areaCode : '251',
              mobilenumber: '',
              fixednumber: '',
              email: '',
              password: '',
              confirmpassword: '',
              expotoken: '',
            }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ handleChange, handleBlur, values, errors, touched }) => (
              <Form>
                <Box component="div" noValidate sx={{ mt: 3 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <Field
                        as={TextField}
                        autoComplete="given-name"
                        name="firstname"
                        required
                        fullWidth
                        id="firstname"
                        label="First Name"
                        autoFocus
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.firstname && Boolean(errors.firstname)}
                        helperText={touched.firstname && errors.firstname}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Field
                        as={TextField}
                        required
                        fullWidth
                        id="middlename"
                        label="Middle Name"
                        name="middlename"
                        autoComplete="middle-name"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.middlename && Boolean(errors.middlename)}
                        helperText={touched.middlename && errors.middlename}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Field
                        as={TextField}
                        required
                        fullWidth
                        id="lastname"
                        label="Last Name"
                        name="lastname"
                        autoComplete="family-name"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.lastname && Boolean(errors.lastname)}
                        helperText={touched.lastname && errors.lastname}
                      />
                    </Grid>
                    {/* <Grid item xs={12}>
                      <Field
                        as={TextField}
                        required
                        fullWidth
                        id="username"
                        label="Username"
                        name="username"
                        autoComplete="username"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.username && Boolean(errors.username)}
                        helperText={touched.username && errors.username}
                      />
                    </Grid> */}
                    <Grid item xs={12} sm={6}>
                      <FormControl fullWidth required>
                        <InputLabel id="role-select-label">Role</InputLabel>
                        <Select
                          labelId="role-select-label"
                          id="role"
                          name="role"
                          label="Role"
                          value={values.role}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={touched.role && Boolean(errors.role)}
                        >
                          <MenuItem value="Supplier">Supplier</MenuItem>
                          <MenuItem value="Customer">Customer</MenuItem>
                        </Select>
                        {touched.role && errors.role && (
                          <div style={{ color: 'red' }}>{errors.role}</div>
                        )}
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <FormControl fullWidth required>
                        <InputLabel id="role-select-label">Country</InputLabel>
                        <Select
                          labelId="role-select-label"
                          id="role"
                          name="countryofresidence"
                          label="Country"
                          value={values.countryofresidence}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={touched.countryofresidence && Boolean(errors.countryofresidence)}
                        >
                          <MenuItem value="Ethiopia">Ethiopia</MenuItem>
                          <MenuItem value="UAE">UAE</MenuItem>
                        </Select>
                        {touched.countryofresidence && errors.countryofresidence && (
                          <div style={{ color: 'red' }}>{errors.countryofresidence}</div>
                        )}
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} container spacing={2}>
                      <Grid item xs={4}>
                        <FormControl fullWidth required>
                          <Select
                            labelId="country-select-label"
                            id="country"
                            name="country"
                            value={values.country}
                            defaultValue=""
                            onChange={handleChange}
                            onBlur={handleBlur}
                            IconComponent={NoDropdownArrow}
                            error={touched.country && Boolean(errors.country)}
                          >
                            {countries.map((country) => (
                              <MenuItem key={country.code} value={country.areaCode}>
                                {country.areaCode}
                              </MenuItem>
                            ))}
                          </Select>
                          {touched.country && errors.country && (
                            <div style={{ color: 'red' }}>{errors.country}</div>
                          )}
                        </FormControl>
                      </Grid>
                      <Grid item xs={8}>
                        <Field
                          as={TextField}
                          required
                          fullWidth
                          id="mobilenumber"
                          label="Phone Number"
                          name="mobilenumber"
                          autoComplete="tel"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={touched.mobilenumber && Boolean(errors.mobilenumber)}
                          helperText={touched.mobilenumber && errors.mobilenumber}
                        />
                      </Grid>
                    </Grid>
                    <Grid item xs={12} container spacing={2}>
                      <Grid item xs={4}>
                        <FormControl fullWidth required>
                          <Select
                            labelId="country-select-label"
                            id="country"
                            name="country"
                            value={values.country}
                            defaultValue=""
                            onChange={handleChange}
                            onBlur={handleBlur}
                            IconComponent={NoDropdownArrow}
                            error={touched.country && Boolean(errors.country)}
                          >
                            {countries.map((country) => (
                              <MenuItem key={country.code} value={country.areaCode}>
                                {country.areaCode}
                              </MenuItem>
                            ))}
                          </Select>
                          {touched.country && errors.country && (
                            <div style={{ color: 'red' }}>{errors.country}</div>
                          )}
                        </FormControl>
                      </Grid>
                      <Grid item xs={8}>
                        <Field
                          as={TextField}
                          required
                          fullWidth
                          id="fixednumber"
                          label="Fixed Number"
                          name="fixednumber"
                          autoComplete="tel"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={touched.fixednumber && Boolean(errors.fixednumber)}
                          helperText={touched.fixednumber && errors.fixednumber}
                        />
                      </Grid>
                    </Grid>
                    <Grid item xs={12}>
                      <Field
                        as={TextField}
                        required
                        fullWidth
                        id="email"
                        label="Email Address"
                        name="email"
                        autoComplete="email"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.email && Boolean(errors.email)}
                        helperText={touched.email && errors.email}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Field
                        as={TextField}
                        required
                        fullWidth
                        name="password"
                        label="Password"
                        type="password"
                        id="password"
                        autoComplete="new-password"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.password && Boolean(errors.password)}
                        helperText={touched.password && errors.password}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Field
                        as={TextField}
                        required
                        fullWidth
                        name="confirmpassword"
                        label="Confirm Password"
                        type="password"
                        id="confirmpassword"
                        autoComplete="new-password"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.confirmpassword && Boolean(errors.confirmpassword)}
                        helperText={touched.confirmpassword && errors.confirmpassword}
                      />
                    </Grid>
                  </Grid>
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                  >
                    Sign Up
                  </Button>
                  <Grid container justifyContent="flex-end">
                    <Grid item>
                      <Link href="/sign-in" variant="body2">
                        Already have an account? Sign in
                      </Link>
                    </Grid>
                  </Grid>
                </Box>
              </Form>
            )}
          </Formik>
        </Box>
        <Copyright sx={{ mt: 5 }} />
      </Container>
    </ThemeProvider>
  );
}